module.exports = {
          srcSet: __webpack_public_path__ + "23a40f48bfd1dea054b5b6d4975039c9-58.png"+" 58w",
          images:[ {path: __webpack_public_path__ + "23a40f48bfd1dea054b5b6d4975039c9-58.png",width: 58,height: 58}],
          src: __webpack_public_path__ + "23a40f48bfd1dea054b5b6d4975039c9-58.png",
          toString:function(){return __webpack_public_path__ + "23a40f48bfd1dea054b5b6d4975039c9-58.png"},
          
          width: 58,
          height: 58
        }